import { Routes } from '@angular/router';
import { adminGuard } from './core/guards/admin.guard';
import { superAdminGuard } from './core/guards/super-admin.guard';

export const routes: Routes = [
  // Dashboard (everyone)
  {
    path: '',
    loadComponent: () => import('./features/dashboard/executive/executive-dashboard.component')
      .then(m => m.ExecutiveDashboardComponent),
  },
  {
    path: 'secteur/:id',
    loadComponent: () => import('./features/dashboard/sector-view/sector-view.component')
      .then(m => m.SectorViewComponent),
  },
  {
    path: 'theme/:id',
    loadComponent: () => import('./features/dashboard/theme-view/theme-view.component')
      .then(m => m.ThemeViewComponent),
  },
  {
    path: 'documentation',
    loadComponent: () => import('./features/documentation/documentation.component')
      .then(m => m.DocumentationComponent),
  },

  // Admin-only routes
  {
    path: 'saisie',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/saisie/saisie-form/saisie-form.component')
      .then(m => m.SaisieFormComponent),
  },
  {
    path: 'qualitatif',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/qualitatif/qualitative-page/qualitative-page.component')
      .then(m => m.QualitativePageComponent),
  },
  {
    path: 'cibles',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/admin/cibles-management/cibles-management.component')
      .then(m => m.CiblesManagementComponent),
  },
  {
    path: 'definitions',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/admin/kpi-definitions/kpi-definitions.component')
      .then(m => m.KpiDefinitionsComponent),
  },
  {
    path: 'specialistes',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/admin/specialistes/specialistes.component')
      .then(m => m.SpecialistesComponent),
  },
  {
    path: 'utilisateurs',
    canActivate: [superAdminGuard],
    loadComponent: () => import('./features/admin/user-management/user-management.component')
      .then(m => m.UserManagementComponent),
  },

  // Adhesion Matrix module
  {
    path: 'adhesion-matrix',
    loadComponent: () => import('./features/adhesion-matrix/pages/matrix-global/matrix-global.component')
      .then(m => m.MatrixGlobalComponent),
  },
  {
    path: 'adhesion-matrix/par-site',
    loadComponent: () => import('./features/adhesion-matrix/pages/matrix-global-site/matrix-global-site.component')
      .then(m => m.MatrixGlobalSiteComponent),
  },
  {
    path: 'adhesion-matrix/synthese',
    loadComponent: () => import('./features/adhesion-matrix/pages/matrix-synthesis/matrix-synthesis.component')
      .then(m => m.MatrixSynthesisComponent),
  },
  {
    path: 'adhesion-matrix/derniere-evaluation',
    loadComponent: () => import('./features/adhesion-matrix/pages/last-evaluation/last-evaluation.component')
      .then(m => m.LastEvaluationComponent),
  },
  {
    path: 'adhesion-matrix/evaluation',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/adhesion-matrix/pages/evaluation/evaluation.component')
      .then(m => m.EvaluationComponent),
  },
  {
    path: 'adhesion-matrix/criteres',
    loadComponent: () => import('./features/adhesion-matrix/pages/criteria-reference/criteria-reference.component')
      .then(m => m.CriteriaReferenceComponent),
  },
  {
    path: 'adhesion-matrix/admin',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/adhesion-matrix/pages/adhesion-admin/adhesion-admin.component')
      .then(m => m.AdhesionAdminComponent),
  },
  {
    path: 'adhesion-matrix/actions',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/adhesion-matrix/pages/actions/actions.component')
      .then(m => m.ActionsComponent),
  },

  // Product Review module
  {
    path: 'product-review',
    loadComponent: () => import('./features/product-review/pages/dashboard/product-executive-dashboard.component')
      .then(m => m.ProductExecutiveDashboardComponent),
  },
  {
    path: 'product-review/product/:id',
    loadComponent: () => import('./features/product-review/pages/product-view/product-view.component')
      .then(m => m.ProductViewComponent),
  },
  {
    path: 'product-review/theme/:id',
    loadComponent: () => import('./features/product-review/pages/theme-view/product-theme-view.component')
      .then(m => m.ProductThemeViewComponent),
  },
  {
    path: 'product-review/saisie',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/product-review/pages/data-entry/product-data-entry.component')
      .then(m => m.ProductDataEntryComponent),
  },
  {
    path: 'product-review/qualitatif',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/product-review/pages/qualitative/product-qualitative-page.component')
      .then(m => m.ProductQualitativePageComponent),
  },
  {
    path: 'product-review/cibles',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/product-review/pages/targets/product-targets-management.component')
      .then(m => m.ProductTargetsManagementComponent),
  },
  {
    path: 'product-review/definitions',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/product-review/pages/definitions/product-kpi-definitions.component')
      .then(m => m.ProductKpiDefinitionsComponent),
  },
  {
    path: 'product-review/documentation',
    loadComponent: () => import('./features/product-review/pages/documentation/product-documentation.component')
      .then(m => m.ProductDocumentationComponent),
  },

  // Fallback
  { path: '**', redirectTo: '' },
];
